const SAMPLE = {
  TEST: 'Test',
  TEST1: 'Test1',
  TEST2: 'Test2',
};

const API_RESPONSE_MESSAGE = {
  UNAUTHORIZED: 'Unauthorized',
  SUCCESS: 'success',
};

const API_RESPONSE_STATUS = {
  SUCCESS: '200',
  BAD_REQUEST: '400',
  UNAUTHORIZED: '401',
  FORBIDDEN: '403',
  NOT_FOUND: '404',
  INTERNAL_SERVER_ERROR: '500',
};

const CHATBOT_STATUS = {
  DRAFT: 'draft',
  LIVE: 'live',
};

const UI_STAFF = 'TGStaff@2025';

const ADMIN_TYPE = {
  SUPER_ADMIN: 'Super-Admin',
  DEPARTMENT: 'Department',
  SUB_DEPARTMENT: 'Sub-Department',
  RL_ADMIN: 'RL-Admin',
};

const QUOTA_TYPE = {
  SUB_DEPARTMENT: 'sub_department',
  FUNCTION_CODE: 'function_code',
  USER: 'user',
};

const ASSIGNMENT_TYPE = {
  DEPARTMENT: 'department_based',
  USER: 'user_based',
};

const ROLE_STATUS = {
  ENABLE: 'enable',
  DISABLE: 'disable',
  DELETE: 'delete',
};

const ROLE_ACTION_LIST = {
  ALL: 'ALL',
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  VIEW: 'VIEW',
};

const ROLE_ACTION_OPTION_LIST = [
  { text: 'All', value: ROLE_ACTION_LIST.ALL },
  // { text: 'Create', value: ROLE_ACTION_LIST.CREATE },
  // { text: 'Edit', value: ROLE_ACTION_LIST.EDIT },
  // { text: 'Delete', value: ROLE_ACTION_LIST.DELETE },
  { text: 'View Only', value: ROLE_ACTION_LIST.VIEW },
];

const TEAM_LIST = {
  BAGGAGE_AND_CLAIMS: 'BAGGAGE_AND_CLAIMS',
  BOOKING_INFORMATION: 'BOOKING_INFORMATION',
  FLIGHT_STATUS_INQUIRIES: 'FLIGHT_STATUS_INQUIRIES',
  LOUNGE_ACCESS_AND_LOYALTY_PROGRAM: 'LOUNGE_ACCESS_AND_LOYALTY_PROGRAM',
  REFUND_OR_TICKET_INQUIRIES: 'REFUND_OR_TICKET_INQUIRIES',
  ROYAL_ORCHID_PLUS: 'ROYAL_ORCHID_PLUS',
  GREETING: 'GREETING',
  FLIGHT_STATUS: 'FLIGHT_STATUS',
  REFUND_OR_TICKET: 'REFUND_OR_TICKET',
  LOUNGE_ACCESS: 'LOUNGE_ACCESS',
  OUT_OF_SCOPE: 'OUT_OF_SCOPE',
  TTCC: 'TTCC',
  ROP: 'ROP',
}


const TEAM_OPTION_LIST = [
  { text: 'Royal Orchid Plus', value: TEAM_LIST.ROYAL_ORCHID_PLUS },
  { text: 'Baggage and Claims', value: TEAM_LIST.BAGGAGE_AND_CLAIMS },
  { text: 'TTCC', value: TEAM_LIST.TTCC },
  // { text: 'Flight Status Inquiries', value: TEAM_LIST.FLIGHT_STATUS_INQUIRIES },
  // { text: 'Lounge Access and Loyalty Program', value: TEAM_LIST.LOUNGE_ACCESS_AND_LOYALTY_PROGRAM },
  // { text: 'Refund or Ticket Inquiries', value: TEAM_LIST.REFUND_OR_TICKET_INQUIRIES },
]

const REPORT_TEAM_OPTION_LIST = [
  { text: 'All', value: null },
  { text: 'Royal Orchid Plus', value: TEAM_LIST.ROP },
  { text: 'TTCC', value: TEAM_LIST.TTCC },
  { text: 'Baggage and Claims', value: TEAM_LIST.BAGGAGE_AND_CLAIMS },
]

const WORKFLOW_TYPE ={
  INITIAL: 'initial',
  WORKFLOW: 'workflow',
}

const SOCIAL_MENU= {
  AI_MANAGEMENT: 'AI_MANAGEMENT',
  KNOWLEDGE_BASE: 'KNOWLEDGE_BASE',
  CONVERSATION_HISTORY: 'CONVERSATION_HISTORY',
  ACCESS_MANAGEMENT: 'ACCESS_MANAGEMENT',
  MANAGE_ROLE: 'MANAGE_ROLE',
  MANAGE_USER: 'MANAGE_USER',
  REPORT: 'REPORT',
  AI_ACCURACY_REPORT: 'AI_ACCURACY_REPORT',
  AI_USAGE_REPORT: 'AI_USAGE_REPORT',
  HISTORY_LOG: 'HISTORY_LOG',
  SEMANTIC_CACHE: 'SEMANTIC_CACHE',
}

const CONVERSATION_CATEGORY ={
  ROP: 'ROP',
  TTCC: 'TTCC',
  BAGGAGE_AND_CLAIMS: 'BAGGAGE_AND_CLAIMS',
  GENERAL_INQUIRY: 'GENERAL_INQUIRY',
}

const CONVERSATION_CATEGORY_OPTION_LIST = [
  { text: 'All', value: null },
  { text: 'Royal Orchid Plus', value: CONVERSATION_CATEGORY.ROP },
  { text: 'TTCC', value: CONVERSATION_CATEGORY.TTCC },
  { text: 'Baggage and Claims', value: CONVERSATION_CATEGORY.BAGGAGE_AND_CLAIMS },
  { text: 'General Inquiry', value: CONVERSATION_CATEGORY.GENERAL_INQUIRY },
]

const HISTORY_LOG_TEAM_OPTION_LIST = [
  { text: 'All', value: null },
  { text: 'Royal Orchid Plus', value: TEAM_LIST.ROP },
  { text: 'TTCC', value: TEAM_LIST.TTCC },
  { text: 'Baggage and Claims', value: TEAM_LIST.BAGGAGE_AND_CLAIMS },
]

const LOG_MENU_LIST = {
  AI_MANAGEMENT: 'preset',
  KNOWLEDGE_BASE: 'knowledge',
  MANAGE_ROLE: 'role',
  MANAGE_USER: 'users',
}

const HISTORY_LOG_MENU_OPTION_LIST = [
  { text: 'All', value: null },
  { text: 'AI Management', value: LOG_MENU_LIST.AI_MANAGEMENT },
  { text: 'Knowledge Base', value: LOG_MENU_LIST.KNOWLEDGE_BASE },
  { text: 'Manage Role', value: LOG_MENU_LIST.MANAGE_ROLE },
  { text: 'Manage User', value: LOG_MENU_LIST.MANAGE_USER },
]

const ACTION_LIST ={
  CREATED: 'created',
  UPDATED: 'updated',
  DELETED: 'deleted',
  APPLIED: 'applied',
}

const HISTORY_LOG_ACTION_OPTION_LIST = [
  { text: 'All', value: null },
  { text: 'Created', value: ACTION_LIST.CREATED },
  { text: 'Updated', value: ACTION_LIST.UPDATED },
  { text: 'Deleted', value: ACTION_LIST.DELETED },
  { text: 'Applied', value: ACTION_LIST.APPLIED },
]

export const ENUM = {
  SAMPLE,
  API_RESPONSE_MESSAGE,
  CHATBOT_STATUS,
  API_RESPONSE_STATUS,
  UI_STAFF,
  ADMIN_TYPE,
  QUOTA_TYPE,
  ASSIGNMENT_TYPE,
  ROLE_STATUS,
  ROLE_ACTION_LIST,
  ROLE_ACTION_OPTION_LIST,
  TEAM_LIST,
  TEAM_OPTION_LIST,
  WORKFLOW_TYPE,
  SOCIAL_MENU,
  REPORT_TEAM_OPTION_LIST,
  CONVERSATION_CATEGORY,
  CONVERSATION_CATEGORY_OPTION_LIST,
  HISTORY_LOG_TEAM_OPTION_LIST,
  HISTORY_LOG_MENU_OPTION_LIST,
  HISTORY_LOG_ACTION_OPTION_LIST,
};